﻿import { initializeVideo, scriptRender } from "./jwplayerVideo.class";

function init($views) {
	scriptRender(`jwplayer/jwplayer.js`, renderJwplayerVideo);

	function renderJwplayerVideo() {
		$views.forEach(($view) => {
			const EmbedIdentifier = $view.dataset.key;
			const VideoPlayerId = $view.dataset.videoPlayerId ? $view.dataset.videoPlayerId : "SLy4o1M2Qg8u8NEzopA4";

			if (!EmbedIdentifier) {
				return;
			}

			var videoContainer = initializeVideo(EmbedIdentifier, VideoPlayerId);

			$view.appendChild(videoContainer);
		});
	}
}

export default {
	view: "jwplayerVideo",
	init,
};
